import { ChannelManager } from './inc/ChannelManager';
import { ParentEvents } from './inc/ParentEvents';
import { RequestService } from './inc/RequestService';

window.channelManager = new ChannelManager();

window.addEventListener('pageshow', (event) => {
	if ( event.persisted || String(window.performance.getEntriesByType('navigation')[0].type) === 'back_forward'  ) {
		var iframes = document.querySelectorAll('[data-pardot-id]');
		iframes.forEach((element) => {
			var iframeSrc = element.src;
			element.src = '';
			element.src = iframeSrc;
		});
	}
});

window.addEventListener('DOMContentLoaded', () => {
	let iframes = document.querySelectorAll('iframe');
	Array.prototype.forEach.call(iframes, (iframe) => {

		let channel = window.channelManager.connect(iframe.contentWindow);


		/**
		 * Diese Funktion übergibt an den Child-Frame die aktuelle URL.
		 */
		channel.on(ParentEvents.ParentUrl, () => {
			return location.href;
		});

		/**
		 * Diese Funktion stellt dem Child-Frame alle Attribute vom eigenen
		 * IFrame-Attribute zur Verfügung. Hiermit können Informationen
		 * wie zum Beispiel die ITM-Parameter übergeben werden.
		 *
		 * @param {Object} args
		 * @return {boolean|String}
		 */
		channel.on(ParentEvents.IFrameAttribute, (args) => {
			let name = args?.name ?? '';

			if (!name) {
				return false;
			}

			if (iframe.hasAttribute(name)) {
				return false;
			}

			let value = iframe.getAttribute(name);
			return value;
		});

		/**
		 * Wenn sich die Höhe des Formulars innerhlab des IFrames verändert,
		 * wird die Größe an das IFrame übergeben, damit diese kein Scrollbalken
		 * ausspielt.
		 *
		 * @param {Object} args
		 * @return {boolean}
		 */
		channel.on(ParentEvents.ResizeFrame, (args) => {
			let height = args?.height ?? 0;

			if (!height) {
				return false;
			}

			iframe.style.height = height + 'px';
			return true;
		});

		/**
		 * Diese Funktion wird abgefeuert, wenn das Child-Frame ein
		 * GTM-Event abfeuern möchte. Dieses Event wird dann auf
		 * der Parent-Seite abgefeuert.
		 *
		 * @param {Object} args
		 * @return {boolean}
		 */
		channel.on(ParentEvents.FireGTM, (args) => {
			let event       = args?.event ?? '';
			let interaction = args?.interaction ?? false;
			let category    = iframe.getAttribute('data-pardot-category') || '';
			let label       = iframe.getAttribute('data-pardot-label') || '';
			if (!event || !category || !label) {
				return false;
			}

			window.dataLayer.push({
				event,
				event_category: category,
				event_label: label,
				non_interaction: !interaction
			});

			return true;
		});

		/**
		 * Bei diesem Event sendet der ParentFrame ein Post-Request
		 * an eine angegeben URL. Sollte keine URL angegeben worden sein,
		 * wird die aktuelle URL verwendet.
		 *
		 * @param {Object} args
		 * @return {boolean}
		 */
		channel.on(ParentEvents.PostRequest, (args) => {
			let url = args?.url ?? window.location.href;
			let data = args?.data ?? {};
			if (!url) {
				return false;
			}

			return RequestService.post(url, data);
		});
	
		/**
		 * Bei diesem Event sendet der ParentFrame ein Post-Request
		 * an eine angegeben URL. Im Vergleich zum normalen
		 * Post-Request wird hier ein FormData an die URL übergeben.
		 * Sollte keine URL angegeben worden sein,
		 * wird die aktuelle URL verwendet.
		 *
		 * @param {Object} args
		 * @return {boolean}
		 */
		channel.on(ParentEvents.UploadRequest, (args) => {
			let url  = args?.url ?? window.location.href;
			let data = args?.data ?? {};

			let formData = new FormData();
			Array.prototype.forEach.call(Object.keys(data), (dataKey) => {
				let dataValue = data[dataKey];

				if (!!dataValue?.filename && !!dataValue?.buffer) {
					let filename = dataValue.filename;
					let buffer = dataValue.buffer;

					let blob = new Blob([buffer], {
						type: 'application/octet-stream'
					});
					let file = new File([blob], filename, {
						type: 'application/octet-stream'
					});
					formData.append(dataKey, file);
				} else {
					formData.append(dataKey, dataValue);
				}
			});

			return RequestService.upload(url, formData);
		});

		/**
		 * Bei diesem Event feuert der Child-Frame ein Get-Request
		 * an die gleiche Domain, wie die Parent-Seite.
		 *
		 * @param {Object} args
		 * @return {boolean}
		 */
		channel.on(ParentEvents.GetRequest, (args) => {
			let url = args?.url ?? window.location.href;
			let data = args?.data ?? {};
			if (!url) {
				return false;
			}

			return RequestService.get(url, data);
		});

		/**
		 * Diese Funktion fängt vom Client die Abfrage nach einem fontcolor ab,
		 * und sendet die passende Klasse und die Schriftfarbe um diese an die
		 * Hintergrundfarbe anzupassen.
		 *
		 * @param {Event} event
		 */
		channel.on(ParentEvents.FontColor, () => {
			var processedElements = new Set();
			/**
			 * Diese Funktion sucht innerhalb des IFrames die Klasse modal-content
			 * und gibt die Erste definition von der Hintergrundfarbe des Iframes zurück.
			 *
			 * @param {HTMLElement} element
			 * @param {Boolean}
			 */
			function hasWhiteBackgroundColor(element) {
				if (processedElements.has(element)) {
					// Element wurde bereits verarbeitet
					return true;
				}
				processedElements.add(element);
				var modalContent = element.closest('.modal-content');

				if (modalContent) {
					//Wir sind in einem Formular das in einem Modal-Fenster angezeigt wird
					var modalBackgroundColor = window.getComputedStyle(modalContent).backgroundColor;
					if (modalBackgroundColor !== '') {
						return modalBackgroundColor === 'rgb(255, 255, 255)' || modalBackgroundColor === '#fff' || modalBackgroundColor === '#ffffff';
					}
				} else {
					//Wir sind in einem Formular das nicht modal angezeigt wird,
					//deswegen brauchen wir hier die Schriftfarbe des Contents um das Formular herum
					var color = window.getComputedStyle(element).color;
					if (color !== '') {
						var parentElement = element.parentElement;
						if (parentElement) {
							var ContentColorParent = window.getComputedStyle(element).color;
							return ! (ContentColorParent === 'rgb(255, 255, 255)' || ContentColorParent === '#fff' || ContentColorParent === '#ffffff');
						}
					}
					// geht rekursive durch alle Eltern-Elemente
					// und gibt die Erste definition von der Schriftfarbe zurück.
					if (parentElement) {
						return hasWhiteBackgroundColor(element.parentElement);
					}
					return true;

				}
				//Bleib bei deiner urpsprünglichen Farbe (schwarz)
				return true;
			}

			return hasWhiteBackgroundColor(iframe);
		});
		channel.on(ParentEvents.WindowSize, () => {
			var windowWidth = window.screen.width;
			function checkWindowWidth(windowWidth) {
				if(windowWidth <= 650){
					return {
						'windowWidth':windowWidth,
						'flexDirection':'column',
						'gap':'15px'
					};
				}
				else {
					return {
						'windowWidth':windowWidth,
						'flexDirection':'inherit',
						'gap':'15px'
					};
				}
			}

			return checkWindowWidth(windowWidth);
		});
	});
});
